module.exports = __webpack_public_path__ + "img/square.02daef76.svg";